export default __webpack_public_path__ + "static/media/buster_klein_59.fc7d569e.jpg";